import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import axios from "axios"
import { useMemo } from "react"
import { useState } from "react"
import Select from 'react-select';
export const FieldsProductosCombos = ({ copiaArray, baseURLInventarios, onChange, i, onClick, onRemove, value, ultimo, primero }) => {
    const [opcionesProducto, setOpcionesProducto] = useState([])
    const [atributosProducto, setAtributosProducto] = useState([])
    const [productoSeleccionadoResultado, setProductoSeleccionadoResultado] = useState([])
    const [cantidad, setCantidad] = useState(null)

    const productosActuales = useMemo(
        () => {
            const newArray = []
            copiaArray && copiaArray.map(pro => {
                if (pro.inventario === 'true' && pro.combo === 'false' && pro.activo === true && parseInt(pro.inventarioCantidad) > 0) {

                    newArray.push({
                        inventarioCantidad: parseInt(pro.inventarioCantidad),
                        label: pro.nombre_producto,
                        value: pro.id,
                        imagePrev: pro.url_imagen,
                        descripcion: pro.descripcion,
                        nombre_producto: pro.nombre_producto,
                        id: pro.id,
                        id_curso: pro.id_curso
                    })
                }
            })
            return newArray
        },
        []
    );

    const productoSeleccionado = async (producto) => {
        try {
            const { data: obtenerAtributos } = await axios(baseURLInventarios, {
                params: {
                    idProducto: producto.value
                }
            })
            if (obtenerAtributos && obtenerAtributos.length > 0) {

                const ids = obtenerAtributos.map(({ padre }) => padre);
                const filtered = obtenerAtributos.filter(({ padre, cantidad }, index) => !ids.includes(padre, index + 1));

                const atributos = []

                filtered.map(atri => {
                    if (parseInt(atri.cantidad) > 0) {
                        atributos.push({ label: atri.padre, value: atri.idAtributo })
                    }
                })
                onChange('producto', producto, i)
                setAtributosProducto(atributos)
                setProductoSeleccionadoResultado(obtenerAtributos)

            } else {
                onChange('producto', producto, i)
                setAtributosProducto(null)
                setProductoSeleccionadoResultado(null)
                setOpcionesProducto(null)
                setCantidad(producto.inventarioCantidad)
            }

        } catch (error) {
            console.log(error)
        }
    }

    const atributosSeleccionado = (atributo) => {
        const opciones = productoSeleccionadoResultado.filter(item => item.padre === atributo.label).map(item => ({ value: item.idAtributo, label: item.nombre, ...item }))
        setOpcionesProducto(opciones)
        onChange('atributos', atributo, i)
    }

    const opcionesSeleccionado = (opciones) => {
        setCantidad(parseInt(opciones.cantidad))
        onChange('opciones', opciones, i)
    }

    const cambiarCantidadActual = (event) => {
        let { value, min, max } = event.target;
        //   console.log(value, 'cantidad')
        // value = Math.max(Number(min), Math.min(Number(max), Number(value)));
        onChange('cantidad', parseInt(value), i)
    }

    return (
        <div className='row align-items-center'>
            <div className='col-md'>
                <label>Producto</label>
                <Select
                    value={value.producto}
                    options={productosActuales}
                    onChange={productoSeleccionado}
                    placeholder='Productos'
                    required
                />
            </div>
            {atributosProducto && atributosProducto.length > 0 ?
                (<div className='col-md p-2'>
                    <label>Atributo</label>
                    <Select
                        value={value.atributos}
                        options={atributosProducto}
                        placeholder='atributos'
                        onChange={atributosSeleccionado}
                        required
                    />
                </div>)
                :
                value && value.atributos ?
                    (<div className='col-md p-2'>
                        <label>Atributo</label>
                        <Select
                            value={value.atributos}
                            options={atributosProducto}
                            placeholder='atributos'
                            onChange={atributosSeleccionado}
                            required
                        />
                    </div>) : null
            }
            {opcionesProducto && opcionesProducto.length > 0 ?
                (<div className='col-md p-2'>
                    <label>Opción</label>
                    <Select
                        value={value.opciones}
                        options={opcionesProducto}
                        placeholder='Opciones'
                        onChange={opcionesSeleccionado}
                        required
                    />
                </div>) :
                value && value.opciones ?
                    (<div className='col-md p-2'>
                        <label>Opción</label>
                        <Select
                            value={value.opciones}
                            options={opcionesProducto}
                            placeholder='Opciones'
                            onChange={opcionesSeleccionado}
                            required
                        />
                    </div>)
                    : null
            }
            <div className="col-md p-2">
                <label>Cantidad</label>
                <input
                    type="number"
                    className="form-control"
                    placeholder="Cantidad"
                    defaultValue={value.cantidad}
                    max={cantidad}
                    min={1}
                    onChange={cambiarCantidadActual}
                    required
                />
            </div>

            <div className='col-md p-0 '>
                <label></label>
                <div className='d-flex'>
                    {ultimo && (<button className='btn boton_estandar-subtotal rounded-pill btn-primary btn-sm' onClick={onClick}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>)}
                    {!primero && <button className='btn btn-danger btn-sm btn-rounded' onClick={() => onRemove(value.id)} >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>}
                </div>

            </div>

        </div>
    )
}